import { ApiError } from '../api/client'
import type { CatalogImportPreviewDto } from '../api/catalogImportTypes'

export const IMPORT_SESSION_EXPIRED_MESSAGE =
  'Сессия импорта истекла. Загрузите прайс заново — правки в каталоге на сессию не влияют.'

export const isPreviewSessionExpired = (preview: CatalogImportPreviewDto): boolean => {
  if (!preview.expiresAt) {
    return false
  }
  return new Date(preview.expiresAt).getTime() <= Date.now()
}

export const previewSessionMinutesLeft = (preview: CatalogImportPreviewDto): number | null => {
  if (!preview.expiresAt) {
    return null
  }
  return Math.floor((new Date(preview.expiresAt).getTime() - Date.now()) / 60_000)
}

const parseApiErrorBody = (message: string): string => {
  const trimmed = message.trim()
  if (!trimmed.startsWith('{')) {
    return trimmed
  }
  try {
    const parsed = JSON.parse(trimmed) as { message?: string }
    return parsed.message?.trim() || trimmed
  } catch {
    return trimmed
  }
}

export const isImportPreviewSessionApiError = (error: unknown): boolean => {
  if (!(error instanceof ApiError) || error.status !== 404) {
    return false
  }
  const text = parseApiErrorBody(error.message).toLowerCase()
  return text.includes('import preview session')
}
